<template>
  <div class="box">
    <role-tab
      :tabs="{
        // haveBind 表示是否要用 binds中的数据
        haveBind: false,
        binds: [],
      }"
      @change="tabHand"
    />
    <h1 class="com-title com-ht"><i></i>授权给我的印章</h1>
    <div class="box-wrap">
      <div class="temone" v-if="defalutChapter.sealName">
        <div class="t-box">
          <img class="y-img" :src="fileOperShow(defalutChapter.sealFile)" />
        </div>
        <p
          :title="`${defalutChapter.sealName}(ID:${defalutChapter.corpSealId})`"
        >
          {{ `${defalutChapter.sealName}(ID:${defalutChapter.corpSealId})` }}
        </p>
        <div class="info_box" v-if="isInDingTalk ? defalutChapter.dingTalkFlow : defalutChapter.flowDetail">
              <el-popover placement="top-start" trigger="click">
                <div style="padding: 10px;font-weight: bold;">
                  <p>
                    {{ isInDingTalk ? defalutChapter.dingTalkFlow.flowName : defalutChapter.flowDetail.flowName }}
                  </p>
                  <div style="height:125px;overflow-y:scroll;">
                    <approval-process
                      :flowInfo="computeInfo(isInDingTalk ? defalutChapter.dingTalkFlow : defalutChapter.flowDetail)"
                      :orderFlag="isInDingTalk ? defalutChapter.dingTalkFlow.flowType : defalutChapter.flowDetail.orderFlag"
                    ></approval-process>
                  </div>
                </div>
                <span class="approve_info" slot="reference">{{
                  isInDingTalk ? defalutChapter.dingTalkFlow.flowName : defalutChapter.flowDetail.flowName
                }}</span>
              </el-popover>
            </div>
      </div>

      <template v-if="chapterList && chapterList.length > 0">
        <div class="temone" v-for="(item, index) in chapterList" :key="index">
          <div class="t-box">
            <img class="y-img" :src="item.signUrl" :title="item.sealName" />
          </div>
          <p :title="`${item.sealName}(ID:${item.corpSealId})`">
            {{ `${item.sealName}(ID:${item.corpSealId})` }}
          </p>
          <div class="info_box" v-if="isInDingTalk ? item.dingTalkFlow : item.flowDetail">
              <el-popover placement="top-start" trigger="click">
                <div style="padding: 10px;font-weight: bold;">
                  <p>
                    {{ isInDingTalk ? item.dingTalkFlow.flowName : item.flowDetail.flowName }}
                  </p>
                  <div style="height:125px;overflow-y:scroll;">
                    <approval-process
                      :flowInfo="computeInfo(isInDingTalk ? item.dingTalkFlow : item.flowDetail)"
                      :orderFlag="isInDingTalk ? item.dingTalkFlow.flowType : item.flowDetail.orderFlag"
                    ></approval-process>
                  </div>
                </div>
                <span class="approve_info" slot="reference">{{
                  isInDingTalk ? item.dingTalkFlow.flowName : item.flowDetail.flowName
                }}</span>
              </el-popover>
            </div>
        </div>
      </template>

      <no-data
        text="企业暂未授权印章给您，如需使用请联系管理员"
        style="margin-top: 30px;"
        v-else-if="!defalutChapter.sealName"
      />
    </div>
  </div>
</template>

<script>
  import RoleTab from "@/components/role-tab";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { getFix } from "@/assets/js/lib/common";
import approvalProcess from "@/components/approval-process/index";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  name: "corpSet",
  components:{approvalProcess, RoleTab},
  props: ['menus'],
  data() {
    return {
      isInDingTalk,
      defalutChapter: {},
      chapterList: [],
      loading: null,
      fileOperShow: fileOperShow
    };
  },
  beforeMount() {
    this.getChapterList();
  },
  methods: {
    tabHand () {
      try {
        if (this.$route.path === this.menus[0].route.path) return
        if (isInDingTalk) {
          this.$router.push({ path: this.menus[0].route.path }, () => { }, () => { })
        }
      } catch (err) {
        console.log('tplRouter_err', err)
      }
    },
    // 获取章列表
    async getChapterList() {
      this.loadingStart();
      let res = await ApiCorpMethods.SealController.listSeals();
      if (res.success) {
        if (res.data) {
          let list = res.data || null;
          if(res.data.length && (res.data[0].sealName)){
            this.defalutChapter = res.data[0] || {};
            list.shift()
          }
          list.forEach(t => {
            t.signUrl = fileOperShow(t.sealFile);
          });
          this.chapterList = list;
        } else {
          this.chapterList = null;
        }
      }
      this.loadingClose();
    },
    computeInfo(obj) {
      let nameList = [],list=[];
      if(isInDingTalk){
        // 钉钉流程 flowType 1:顺序审（多层，每层一个），2：会审（单层，一层多个
        if(obj){
          const {nodes} = obj.flowParam || {};
          nodes && nodes.forEach((node) => {
            nameList.push(...(node.userApproveUsers.map(user => user.name)))
          })
        list = nameList.map(name => {
          return {partyName: name};
        });
        }
      }else{
        const keyStr = obj.orderFlag ? "->" : "、"
        nameList =obj.allPartName.split(keyStr);
        list = nameList.map(name => {
          return {partyName: name};
        });
      }
      return list;
    },
    loadingStart() {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true
      });
    },
    loadingClose() {
      if (this.loading) this.loading.close();
    }
  }
};
</script>

<style lang="less" scoped>
.box {
  .title {
    height: 46px;
    line-height: 46px;
    background-color: rgb(242, 242, 242);
    font-size: 14px;
    font-weight: 700;
    color: #666;
    padding: 0 10px;
  }
  .seal-wrap {
    padding: 20px 20px 0 20px;
    height: calc(100vh - 210px);
    overflow-y: auto;
  }
  .card {
    width: 250px;
    position: relative;
    border: 1px solid #cccccc;
    .add-sign {
      height: 140px;
      line-height: 140px;
      text-align: center;
      cursor: pointer;
      i {
        font-size: 64px;
        vertical-align: middle;
      }
    }

    .bottom {
      padding: 10px 8px;
      background-color: #f8f8f8;
      border-top: 0;
      color: #333;
      font-size: 12px;
      text-align: left;

      .add {
        cursor: pointer;
      }

      .action span {
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .img-box {
      text-align: center;
      height: 140px;
      line-height: 140px;
      border-bottom: 1px solid #cccccc;
      img {
        max-height: 90px;
        vertical-align: middle;
      }
    }

    .del-sign {
      display: none;
      position: absolute;
      color: #cccccc;
      right: 5px;
      top: 5px;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .card:hover {
    .del-sign,
    .del-sign:hover {
      display: inline-block;
    }
  }

  p.sign-name {
    width: 250px;
    line-height: 20px;
    height: 20px;
    margin: 5px 0;
  }
}

h4 {
  margin: 0;
  padding: 12px;
  background-color: #f8f8f8;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-top: -15px;
  padding: 15px;
  &:last-child {
    margin-bottom: 130px;
  }
  .temone {
    margin-left: 20px;
    margin-top: 15px;
    width: 175px;
    text-align: center;
    align-items: center;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    // height: 140px;
    &.add {
      cursor: pointer;
      height: 140px;
      line-height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
      }
    }
    p {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      width: 100%;
      font-family: Source Han Sans SC;
      box-sizing: border-box;
      height: 35px;
      line-height: 35px;
      background: rgba(239, 239, 239, 1);
      color: rgba(41, 2, 2, 0.65);
    }
    .t-box {
      position: relative;
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        width: 96px;
        height: auto;
        display: block;
        margin: 8px auto 7px auto;
      }
      .msk {
        transition: all ease 0.2s;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        padding: 8px 8px;
        box-sizing: border-box;
        z-index: 10;
        span {
          cursor: pointer;
          float: right;
          color: #ffffff;
          font-size: 20px;
          margin-left: 10px;
          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
        .setmr-btn {
          float: left;
          font-size: 14px;
          margin-left: 0;
        }
      }
      .mr-label {
        position: absolute;
        left: 3px;
        top: 3px;
        font-size: 12px;
        color: rgba(236, 28, 28, 1);
        z-index: 5;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: #c9bfbf;
      font-size: 80px;
    }
  }
}
.info_box {
  width: 100%;
  margin: 10px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  .approve_info {
  cursor: pointer;
  font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/corpSet.vue